<button type="button" data-sidebar-opener class="sidebar-launcher" aria-label="Open navigation" aria-controls="kite-navigation"
  [attr.aria-expanded]="sidebarService.mobileOpen()" [hidden]="sidebarService.mobileOpen()" (click)="openMobile($event)">
  <lucide-icon [img]="icons['expand']" [size]="22" aria-hidden="true" />
</button>
@if (sidebarService.mobileOpen()) {
  <div class="sidebar-backdrop" (click)="sidebarService.closeMobile()" aria-hidden="true"></div>
}
<div #panel id="kite-navigation" class="kite-sidebar" [class.mini]="sidebarService.miniSidebar"
  [class.mobile-open]="sidebarService.mobileOpen()" [attr.role]="sidebarService.mobileOpen() ? 'dialog' : 'complementary'"
  [attr.aria-modal]="sidebarService.mobileOpen() ? 'true' : null" aria-label="KitePro navigation">
  <header class="sidebar-brand">
    <img class="brand-logo logo-mini" src="/assets/images/logos/kitegroup.png" alt="Kite Group" width="34" height="34" />
    <img class="brand-logo logo-expanded" src="/assets/images/logos/KITEPro logo small.png" alt="KitePro" />
    <button data-mobile-close type="button" class="mobile-close icon-button" aria-label="Close navigation" (click)="sidebarService.closeMobile()">
      <lucide-icon [img]="icons['close']" [size]="18" aria-hidden="true" />
    </button>
  </header>
  <div class="sidebar-search sidebar-label">
    <lucide-icon [img]="icons['search']" [size]="16" aria-hidden="true" />
    <input aria-label="Search navigation" placeholder="Search navigation…" [value]="query()" (input)="query.set($any($event.target).value)" />
  </div>
  <nav aria-label="Modules" class="sidebar-scroll">
    @if (sidebarService.showHome && !query()) {
      <a class="sidebar-link" routerLink="/uco/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page" title="Home">
        <lucide-icon [img]="icons['home']" [size]="18" aria-hidden="true" /><span class="sidebar-label">Home</span>
      </a>
    }
    @if (sidebarService.showReports && !query()) {
      <a class="sidebar-link" routerLink="/uco/reports" routerLinkActive="active" ariaCurrentWhenActive="page" title="Reports">
        <lucide-icon [img]="icons['reports']" [size]="18" aria-hidden="true" /><span class="sidebar-label">Reports</span>
      </a>
    }
    @for (group of visibleGroups(); track group.id) {
      <section class="sidebar-group" [class.settings-group]="group.id === 'settings'" [attr.aria-label]="group.titulo">
        <button type="button" class="sidebar-link group-toggle" [attr.title]="group.titulo"
          [attr.aria-label]="group.titulo" [attr.aria-expanded]="expanded(group) && (!sidebarService.miniSidebar || sidebarService.mobileOpen())"
          [attr.aria-controls]="'navigation-' + group.id" (click)="sidebarService.toggleSubmenu(group)">
          <lucide-icon [img]="icons[group.icon]" [size]="18" aria-hidden="true" />
          <span class="sidebar-label">{{group.titulo}}</span>
          <lucide-icon class="chevron sidebar-label" [class.open]="expanded(group)" [img]="icons['chevron']" [size]="16" aria-hidden="true" />
        </button>
        <ul class="sidebar-children" [id]="'navigation-' + group.id" [hidden]="!expanded(group)">
          @for (item of group.submenu; track item.id) {
            <li><a class="sidebar-link" [routerLink]="item.url" [class.active]="sidebarService.isActive(item)"
              [attr.aria-current]="sidebarService.isActive(item) ? 'page' : null" [attr.title]="item.titulo">
              <lucide-icon [img]="icons[item.icon]" [size]="16" aria-hidden="true" /><span>{{item.titulo}}</span>
            </a></li>
          }
        </ul>
      </section>
    } @empty { <p class="empty-search sidebar-label" role="status">No matching destinations</p> }
  </nav>
  <footer class="kite-sidebar-footer">
    <button type="button" class="sidebar-link desktop-toggle" (click)="sidebarService.toggleSidebar()"
      [attr.aria-label]="sidebarService.miniSidebar ? 'Expand navigation' : 'Collapse navigation'">
      <lucide-icon [img]="icons[sidebarService.miniSidebar ? 'expand' : 'collapse']" [size]="18" aria-hidden="true" />
      <span class="sidebar-label">Collapse navigation</span>
    </button>
    <small class="sidebar-label version">v{{appVersion}}</small>
  </footer>
</div>
